const C = {
  name: "ArrowCircleUpFilled",
  dimensions: { width: 22, height: 22 },
  content: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C4.93 0 0 4.93 0 11C0 17.07 4.93 22 11 22C17.07 22 22 17.07 22 11C22 4.93 17.07 0 11 0ZM15.71 11.71C15.51 11.91 15.26 12 15 12C14.74 12 14.49 11.9 14.29 11.71L12 9.42V15.01C12 15.56 11.55 16.01 11 16.01C10.45 16.01 10 15.56 10 15.01V9.42L7.71 11.71C7.32 12.1 6.69 12.1 6.3 11.71C5.91 11.32 5.91 10.69 6.3 10.3L10.3 6.3C10.39 6.21 10.5 6.13 10.63 6.08C10.87 5.98 11.15 5.98 11.39 6.08C11.51 6.13 11.62 6.2 11.72 6.3L15.72 10.3C16.11 10.69 16.11 11.32 15.72 11.71H15.71Z" fill="currentColor"/>`
};
export {
  C as ArrowCircleUpFilled
};
